import React, {Component} from "react";
import {ADGROUP_STATUS_ACTIVE} from "../../../marketing";

export class AdgroupNameCell extends Component {

    renderStatus() {
        if(this.props.status !== ADGROUP_STATUS_ACTIVE)
            return <span className="ml-2 mr-2  status_not_active">[No activo]</span>
        return ""
    }

    renderName() {
        if(this.props.insideCampaignRow)
            return <span>➡️ {this.props.adgroupName}{this.renderStatus()}</span>;
        return <span>{this.props.campaignName} ➡️ {this.props.adgroupName}{this.renderStatus()}</span>;
    }

    render() {
        return (
            <td>
                <div className="bu-cell ad_account_row">
                    <div className="bu-name-with-tooltip">
                        <div className="adgroup-name" title={this.props.adgroupName}>
                            {this.renderName()}
                        </div>
                    </div>
                    <div className="some-icons">
                        &nbsp;
                    </div>
                </div>
            </td>
        );
    }
}
